import { supabase } from '@/lib/supabase';
import type { AdvancePayment } from '@/lib/database.types';

/** Όλες οι προκαταβολές μιας συμφωνίας (νεότερες πρώτα). */
export async function listAdvancePayments(agreementId: string): Promise<AdvancePayment[]> {
  const { data, error } = await supabase
    .from('advance_payments')
    .select('*')
    .eq('agreement_id', agreementId)
    .order('created_at', { ascending: false });
  if (error) throw error;
  return data ?? [];
}

/** Καταγραφή προκαταβολής (πρόταση) — μένει 'pending' μέχρι να απαντήσει ο άλλος. */
export async function proposeAdvancePayment(
  agreementId: string,
  proposerId: string,
  amount: number,
  note?: string | null,
): Promise<AdvancePayment> {
  const { data, error } = await supabase
    .from('advance_payments')
    .insert({
      agreement_id: agreementId,
      proposer_id: proposerId,
      amount,
      note: note?.trim() || null,
    })
    .select('*')
    .single();
  if (error) throw error;
  return data;
}

/** Αποδοχή/απόρριψη προκαταβολής (μόνο ο άλλος, μέσω RPC). */
export async function respondAdvancePayment(paymentId: string, accept: boolean): Promise<void> {
  const { error } = await supabase.rpc('respond_advance_payment', {
    payment_id: paymentId,
    accept,
  });
  if (error) throw error;
}

/** Άθροισμα αποδεκτών προκαταβολών. */
export function acceptedAdvanceTotal(items: AdvancePayment[]): number {
  return items
    .filter((i) => i.status === 'accepted')
    .reduce((sum, i) => sum + Number(i.amount), 0);
}
